import type { Route } from 'next'

export function linkResolver(record: any, isInternational?: boolean): Route {
	if (!record?.__typename) {
		return '/' as Route
	}

	switch (record.__typename) {
		case 'PageRecord':
			return `/${record.slug}` as Route

		case 'NewsRecord':
			return `/news/${record.slug}` as Route

		case 'NewsPageRecord':
		case 'news_page':
			return `/news` as Route

		case 'ProductRecord':
			if (isInternational) {
				return `/car-haulers/international/${record.slug}` as Route
			}
			return `/car-haulers/${record.slug}` as Route

		default:
			return '/' as Route
	}
}
